document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".faq-tab");
  const groups = document.querySelectorAll(".faq-group");
  const questions = document.querySelectorAll(".faq-question");

  // Inicializa as respostas escondidas
  document.querySelectorAll(".faq-answer").forEach(answer => {
    answer.style.display = "none";
  });

  // Tabs
  tabs.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      // Ativar a tab clicada
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      // Mostrar grupo correspondente
      const target = tab.dataset.target;
      groups.forEach(group => {
        if (group.id === target) {
          group.classList.add("show");
        } else {
          group.classList.remove("show");
        }
      });

      // Fechar todas as respostas ao trocar de grupo
      document.querySelectorAll(".faq-answer").forEach(answer => {
        answer.style.display = "none";
      });
      questions.forEach(q => q.classList.remove("active"));
    });
  });

  // Expansão das perguntas
  questions.forEach(q => {
    q.addEventListener("click", () => {
      const answer = q.nextElementSibling;
      const isActive = q.classList.contains("active");

      // Fechar todos
      questions.forEach(q2 => q2.classList.remove("active"));
      document.querySelectorAll(".faq-answer").forEach(a => {
        a.style.display = "none";
      });

      // Abrir se não estava já aberto
      if (!isActive) {
        q.classList.add("active");
        answer.style.display = "block";
      }
    });
  });
});
